import { render, staticRenderFns } from "./MyPaperReportList.vue?vue&type=template&id=59c36e48&style=height%3A%20100%25%3B"
import script from "./MyPaperReportList.vue?vue&type=script&lang=js"
export * from "./MyPaperReportList.vue?vue&type=script&lang=js"
import style0 from "./MyPaperReportList.vue?vue&type=style&index=0&id=59c36e48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports